export const initialState = {
  fileName: '',
  fileType: '',
  fileFormatId: '',
}

export enum ActionType {
  reset = 'reset',
  setFileType = 'setFileType',
  setFileName = 'setFilename',
  setFileFormatId = 'setId',
  setAll = 'setAll',
}

type Action =
  | { type: ActionType.reset }
  | { type: ActionType.setFileName; payload: string }
  | { type: ActionType.setFileType; payload: string }
  | { type: ActionType.setFileFormatId; payload: string }
  | { type: ActionType.setAll; payload: typeof initialState }

/**
 * Export template dialog reducer.
 *
 * @param {} state
 * @param {} action
 * @returns {}
 */
export function reducer(state: typeof initialState, action: Action) {
  switch (action.type) {
    case ActionType.setFileName: {
      return {
        ...state,
        fileName: action.payload,
      }
    }
    case ActionType.setFileType: {
      return {
        ...state,
        fileType: action.payload,
      }
    }
    case ActionType.setFileFormatId: {
      return {
        ...state,
        email: action.payload,
      }
    }
    case ActionType.setAll: {
      return action.payload
    }
    case ActionType.reset: {
      return {
        ...state,
        ...initialState,
      }
    }
    default:
      return state
  }
}
